import { Crisp } from "crisp-sdk-web";
import { CRISP_WEBSITE_ID } from "../config";

let crispConfigured = false;

const setupCrispChat = (
  webSiteId: string | undefined,
  token: string,
  email: string,
  owner: string,
  companyInfo: { siteName: string; url: string },
  data: any,
) => {
  if (!webSiteId) return;

  setTimeout(() => {
    try {
      Crisp.configure(webSiteId);
      Crisp.setTokenId(token);

      Crisp.user.setEmail(email);
      Crisp.user.setNickname(owner);
      Crisp.user.setCompany(companyInfo.siteName, {
        url: companyInfo.url,
      });

      Crisp.session.setData(data);
      crispConfigured = true;
    } catch (error) {
      console.log("Error while configuring Crisp chat", error);
    }
  }, 3000);
};

const showCrispChat = () => {
  if (!crispConfigured) return;

  try {
    Crisp.chat && Crisp.chat.show();
  } catch (error) {
    console.log("Error while showing Crisp chat", error);
  }
};

const hideCrispChat = () => {
  if (!crispConfigured) return;

  try {
    Crisp.chat && Crisp.chat.hide();
  } catch (error) {
    console.log("Error while hiding Crisp chat", error);
  }
};

const isCrispVisible = () => {
  if (!crispConfigured) return false;

  try {
    return CRISP_WEBSITE_ID && Crisp.chat && Crisp.chat.isVisible();
  } catch (error) {
    console.log("Error while checking crisp", error);

    return false;
  }
};

const openCrispChat = () => {
  if (!crispConfigured) return;

  try {
    Crisp.chat && Crisp.chat.open();
  } catch (error) {
    console.log("Error while showing Crisp chat", error);
  }
};

/**
 * Sends a support request message in Crisp chat (title + description).
 * Formats as: *title* then 📝 description.
 * Does not open the chat; call showCrispChat() first if the chat should be visible.
 */
const sendSupportMessage = (title: string, description: string) => {
  if (!crispConfigured) return;

  try {
    const text = `*${title}*\n📝 ${description}`;

    Crisp.message?.send("text", text);
  } catch (error) {
    console.log("Error while sending Crisp support message", error);
  }
};

export { hideCrispChat, isCrispVisible, openCrispChat, sendSupportMessage, setupCrispChat, showCrispChat };
